export const SET_NAVIGATION_LOCATION = '@@react-pages/set-navigation-location'